import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';
import { smsSelectors } from '@polyai/stream/store/reducers/sms/index';

export const selectSmsSlice = (state: RootState) => state.sms;

export const selectSmsByIds = createSelector(
  [selectSmsSlice, (_state: RootState, ids: string[]) => ids],
  ({ templates }, ids) => {
    return ids.map(id => {
      return smsSelectors.selectById(templates, id);
    });
  },
);

export const selectSmsById = createSelector(
  [selectSmsSlice, (_state: RootState, id: string) => id],
  ({ templates }, id) => {
    if (!templates || !id) {
      return undefined;
    }
    return smsSelectors.selectById(templates, id);
  },
);

export const selectActiveSmsTemplates = createSelector(
  [selectSmsSlice],
  ({ templates }) => {
    return smsSelectors.selectAll(templates).filter(t => t.active);
  },
);
